module.exports = __webpack_public_path__ + "static/img/A125.b78616cb.jpg";